import { useState } from "react";
import AccordionServicos from "../../components/accordionServicos";
import Badge from "../../components/badge";
import BannerProjects from "../../components/bannerProjects";
import CardServicos from "../../components/cardServicos";
import CardsVerticais from "../../components/cardsVerticais";
import Container from "../../components/container";
import Rodape from "../../components/rodape";
import SquadBeneficios from "../../components/squadBeneficios";
import { useModal } from "../../contexts/ModalContext";
import FormularioRD from "../../rdstation/formularioRD";
import BusinessOtimize from "../../components/businessOtimize";
import OtimizeSeuNegocio from "../../components/OtimizeSeuNegocio";

export default function Monitoramento() {
    const { openModal } = useModal();
    const [hoveredCardIndex, setHoveredCardIndex] = useState(null);
    const [hoveredBeneficioIndex, setHoveredBeneficioIndex] = useState(null);
    const [expandedMobileIndex, setExpandedMobileIndex] = useState(null);
    
    // Handle accordion toggle in mobile view - similar to squadBeneficios.jsx
    const handleAccordionToggle = (index, isOpen) => {
        if (isOpen) {
            // Close any previously opened accordion
            if (expandedMobileIndex !== null && expandedMobileIndex !== index) {
                // Find the previously opened accordion and close it
                const prevAccordion = document.querySelector(`[data-accordion-index="${expandedMobileIndex}"]`);
                if (prevAccordion) {
                    prevAccordion.click();
                }
            }
            setExpandedMobileIndex(index);
        } else if (expandedMobileIndex === index) {
            setExpandedMobileIndex(null);
        }
    };
    const mock = [
        {
            label: "Backup",
        },
        {
            label: "Banco de dados",
        },
        {
            label: "Aplicações",
        },
        {
            label: "Custos",
        },
        {
            label: "Network",
        },
        {
            label: "Suporte",
        },
        {
            label: "Workland",
        },
        {
            label: "Segurança",
        },
    ];
    const expertiseSections = [
        {
            id: 1,
            title: "Análise Automatizada",
            content: "Algoritmos identificam padrões e anomalias.",
        },
        {
            id: 2,
            title: "Coleta em Tempo Real",
            content: "Agregação de dados de performance, logs e eventos.",
        },
        {
            id: 3,
            title: "Alertas Imediatos",
            content: "Notificações em tempo real para problemas críticos.",
        },
    ];
    const cards = [
        {
            id: 1,
            icon: "../assets/icones/monitoramento/experiencia.svg",
            title: "Experiência do usuário",
            text: "Garanta consistência, eficiência e qualidade.",
            glowColor: "#FC0021",
        },
        {
            id: 2,
            icon: "../assets/icones/monitoramento/escala.svg",
            title: "Escalabilidade",
            text: " Faça ajustes em tempo real para atender às mudanças na demanda.",
            glowColor: "#FC0021",
        },
        {
            id: 3,
            icon: "../assets/icones/monitoramento/reducao.svg",
            title: "Redução de custos",
            text: "Evite desperdícios e gastos desnecessários.",
            glowColor: "#FC0021",
        },
    ];
    const beneficios = [
        {
            id: 1,
            icon: "../assets/icones/monitoramento/deteccao.svg",
            title: "Detecção precoce",
            text: "Identifique e neutralize ameaças, evitando danos e prejuízos ao seu negócio.",
            glowColor: "#FC0021",
        },
        {
            id: 2,
            icon: "../assets/icones/monitoramento/conformidade.svg",
            title: "Conformidade",
            text: "Aplique medidas de segurança em tempo real para minimizar e mitigar riscos.",
            glowColor: "#FC0021",
        },
        {
            id: 3,
            icon: "../assets/icones/monitoramento/reducao.svg",
            title: "Redução de custos",
            text: "Aplique medidas de segurança em tempo real para minimizar e mitigar riscos.",
            glowColor: "#FC0021",
        },
    ];

    return (
        <>
            <BannerProjects
                backgroundImage="../assets/cover-monitoramento.png"
                bgMobile="../assets/cover-monitoramento-mobile.png"
                title={
                    <>
                        /MONITORAMENTO <br />
                        <strong className="font-inter-regular">CONTÍNUO</strong>
                    </>
                }
                iconSrc="../assets/icone-projectiva-nex2ai.png"
                iconAlt="Projectiva Nex2AI"
                iconText="omni"
                iconTextBold="core"
                descriptionBold=""
                description={
                    <>
                        <strong className="font-inter-bold">
                            Gestão descomplicada da sua infraestrutura em nuvem
                        </strong>{" "}
                        com monitoramento proativo, gerenciamento inteligente de
                        recursos, otimização de custos e suporte especializado,
                        para que você foque no crescimento do seu negócio.
                    </>
                }
                footerText="VERTICAL INNOVATION | Cloud"
                buttonText="Quero me conectar"
                buttonColor="from-[#FC0021] via-[#FC0021] to-[#5534D9]"
                brand="nex2ai"
            />
            <section className="bg-[rgba(4,1,22,1)]">
                <div className="pt-20 pb-9 px-0">
                    <div className="flex justify-center gap-2 overflow-x-scroll lg:overflow-hidden lg:flex-wrap">
                        {mock.map((item, index) => (
                            <Badge key={index} className="min-w-fit">
                                {item.label}
                            </Badge>
                        ))}
                    </div>
                </div>
            </section>
            <SquadBeneficios
                title={
                    <p className="text-3xl text-center lg:text-left lg:text-5xl font-inter-light">
                        Monitore e proteja sua nuvem em tempo real com{" "}
                        <span className="bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#5534D9] bg-clip-text text-transparent relative w-fit">
                            máxima eficiência
                        </span>
                    </p>
                }
                cards={[
                    {
                        id: 1,
                        icon: "../assets/icones/monitoramento/monitoramento.svg",
                        title: "Monitoramento proativo",
                        text: "Antecipamos problemas e geramos soluções com agilidade.",
                        glowColor: "#FC00218C",
                        doesThereButton: false,
                    },
                    {
                        id: 2,
                        icon: "../assets/icones/monitoramento/gerenciamento.svg",
                        title: "Gerenciamento de recursos:",
                        text: "Ajustamos sua infraestrutura para garantir eficiência e evitar desperdícios.",
                        glowColor: "#FC00218C",
                        doesThereButton: false,
                    },
                    {
                        id: 3,
                        icon: "../assets/icones/monitoramento/otimizacao.svg",
                        title: "Otimização de custos",
                        text: "Analisamos seu uso de recursos para maximizar a economia.",
                        glowColor: "#FC00218C",
                        doesThereButton: false,
                    },
                    {
                        id: 4,
                        icon: "../assets/icones/monitoramento/suporte.svg",
                        title: "Suporte especializado",
                        text: "Proporcionamos suporte contínuo para alinhar a infraestrutura aos objetivos do seu negócio.",
                        glowColor: "#FC00218C",
                        doesThereButton: false,
                    },
                    {
                        id: 5,
                        icon: "../assets/icones/monitoramento/foco.svg",
                        title: "Foco no seu negócio",
                        text: "Simplificamos a gestão da nuvem, permitindo que você se concentre no que realmente importa.",
                        glowColor: "#FC00218C",
                        doesThereButton: false,
                    },
                ]}
            />
            <section className="bg-[url(../assets/banner-monitoramento-otimize.png)] bg-cover text-white">
                <Container className="py-16 md:py-32 grid grid-cols-1 lg:grid-cols-2 items-center gap-18">
                    <div className="md:space-y-6 flex flex-col items-center md:block">
                        <div className="font-inter-light text-xl md:text-3xl text-center md:text-left px-2 md:px-0">
                            <span className="font-inter-bold">
                                Com o monitoramento contínuo, tenha análises de
                                dados em tempo real na nuvem
                            </span>
                            , identificando problemas para impulsionar melhorias
                            e otimizações constantes.
                        </div>
                        <button
                            type="button"
                            onClick={() => openModal(<FormularioRD />)}
                            className="hidden md:block bg-white font-bold py-3 px-8 rounded-full shadow-md hover:scale-105 transition-transform duration-300 cursor-pointer"
                            style={{
                                background: "white",
                                backgroundClip: "padding-box",
                            }}
                        >
                            <span className="text-[#FC0021]">
                                Otimize seus negócios
                            </span>
                        </button>
                    </div>
                    <CardsVerticais
                        initialSections={expertiseSections}
                        height="h-[130px]"
                        color="#F22D44"
                    />
                    <div className="space-y-6 md:space-y-0 flex flex-col items-center block md:hidden ">
                        <button
                            type="button"
                            onClick={() => openModal(<FormularioRD />)}
                            className="bg-white font-bold py-6 px-8 rounded-full shadow-md hover:scale-105 transition-transform duration-300 cursor-pointer"
                            style={{
                                background: "white",
                                backgroundClip: "padding-box",
                            }}
                        >
                            <span className="text-[#FC0021]">
                                Otimize seus negócios
                            </span>
                        </button>
                    </div>
                </Container>
            </section>
            <section className="text-white bg-[#040119] relative overflow-hidden">
                <Container className="pt-14 pb-32 md:py-24 space-y-12 md:space-y-28 px-8">
                    <header className="text-center drop-shadow-[0_5px_5px_rgb(19,20,24)]">
                        <h2 className="text-3xl md:text-6xl drop-shadow-lg">
                            Principais <br className="md:hidden" /> benefícios
                        </h2>
                    </header>
                    <main className="relative z-10 flex flex-col md:flex-row gap-12 md:gap-8 py-12 md:py-0 backdrop-blur-xl bg-[#FFFFFF17] rounded-[10px] border border-white w-fit">
                        <div className="text-center flex flex-col items-center justify-center md:py-14 px-12">
                            <h3 className="text-2xl font-inter-bold mb-4">
                                Resolução Ágil:
                            </h3>
                            <p className="text-white max-w-xs font-inter-regular text-xl">
                                Identificação e correção rápida de falhas.
                            </p>
                        </div>

                        <div className="w-[120px] h-px md:h-[120px] md:w-px bg-[#C4C4C4] m-auto" />

                        <div className="text-center flex flex-col items-center justify-center md:py-14 px-8">
                            <h3 className="text-2xl font-inter-bold mb-4">
                                Melhoria Contínua:
                            </h3>
                            <p className="text-white max-w-xs font-inter-regular text-xl">
                                Feedback constante para otimizações.
                            </p>
                        </div>

                        <div className="w-[120px] h-px md:h-[120px] md:w-px bg-[#C4C4C4] m-auto" />

                        <div className="text-center flex flex-col items-center justify-center md:py-14 px-8">
                            <h3 className="text-2xl font-inter-bold mb-4">
                                Segurança Fortalecida:
                            </h3>
                            <p className="text-white max-w-xs font-inter-regular text-xl">
                                Detecção precoce de ameaças e vulnerabilidades.
                            </p>
                        </div>
                    </main>
                </Container>
                <img
                    src="../assets/cover-maxima-seguranca.png"
                    alt=""
                    className="absolute left-0 bottom-0 w-full scale-300 md:scale-100 "
                />
            </section>
            <section className="bg-[rgba(4,1,22,1)] text-white py-24 pb-16">
                <Container className="flex flex-col lg:flex-row items-center gap-[60px]">
                    <div className="lg:w-1/3">
                        <h2 className="text-3xl md:text-4xl font-inter-light mb-0 md:mb-2 text-center lg:text-left">
                            Monitoramento de <br className="lg:hidden" />
                            <span className="bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#5534D9] bg-clip-text text-transparent">
                                Performance e<br />
                                Disponibilidade
                            </span>
                        </h2>
                    </div>
                    <div className="lg:w-2/3">
                        <p className="text-center lg:text-left text-[18px] md:text-2xl">
                            Ao monitorar a performance e disponibilidade da sua
                            infraestrutura e aplicações na nuvem, garanta
                            operações de alta performance, mesmo em indicadores
                            críticos, como tempo de resposta, uso de CPU,
                            memória e latência.
                        </p>
                    </div>
                </Container>
            </section>
            <section>
                <div className="w-full bg-[rgba(4,1,22,1)] pt-8 pb-14 lg:pb-40 relative overflow-hidden">
                    <Container className="relative z-10">
                        <>
                            <h3 className="font-inter-light text-2xl mb-8 md:text-[40px] md:mb-14 text-center text-white">
                                Por que é importante:
                            </h3>

                            <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-6">
                                {cards.map((card, index) => (
                                    <div key={index} className="relative">
                                        <div
                                            className="relative"
                                            onMouseEnter={() =>
                                                setHoveredCardIndex(index)
                                            }
                                            onMouseLeave={() =>
                                                setHoveredCardIndex(null)
                                            }
                                        >
                                            <CardServicos
                                                icon={card.icon}
                                                iconHover={
                                                    card.iconHover || card.icon
                                                }
                                                title={card.title}
                                                text={card.text}
                                                glowColor={
                                                    card.glowColor || "#A002CB"
                                                }
                                                url={card.url}
                                                className="w-full"
                                            />

                                            {/* OtimizeSeuNegocio component that appears on hover */}
                                            <div
                                                className={`absolute left-0 right-0 bottom-[-110px] transition-all duration-300 ${
                                                    hoveredCardIndex === index
                                                        ? "opacity-100 visible"
                                                        : "opacity-0 invisible"
                                                }`}
                                            >
                                                <OtimizeSeuNegocio
                                                    text="Otimize seu negócio!"
                                                    buttonText="Contratar"
                                                    useFormularioRD={true}
                                                    type="solidOrange"
                                                    className="w-full"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="md:hidden space-y-3">
                                {cards.map((card, index) => (
                                    <div key={index} className="relative">
                                        <AccordionServicos
                                            {...card}
                                            className="text-left"
                                            doesThereButton={false}
                                            onToggle={(isOpen) => handleAccordionToggle(`card-${index}`, isOpen)}
                                            accordionIndex={`card-${index}`}
                                            isOpen={expandedMobileIndex === `card-${index}`}
                                        />
                                        
                                        {/* Otimize component that appears when accordion is expanded */}
                                        <div 
                                            className={`transition-all duration-300 ease-in-out transform w-full overflow-hidden
                                                ${expandedMobileIndex === `card-${index}` ? 'max-h-[100px] opacity-100 mt-3' : 'max-h-0 opacity-0'}`}
                                            style={{
                                                transitionProperty: 'max-height, opacity, transform, margin',
                                                transform: expandedMobileIndex === `card-${index}` ? 'translateY(0)' : 'translateY(-10px)',
                                                zIndex: 20,
                                                position: 'relative'
                                            }}
                                        >
                                            <OtimizeSeuNegocio 
                                                text="Otimize seu negócio!"
                                                buttonText="Contratar"
                                                useFormularioRD={true}
                                                type="solidOrange"
                                                className="w-full"
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    </Container>
                </div>
            </section>
            <section className="bg-[rgba(4,1,22,1)] text-white py-4">
                <Container className="flex flex-col lg:flex-row items-center gap-7 md:gap-[60px]">
                    <div className="lg:w-1/3">
                        <h2 className="text-3xl md:text-4xl font-inter-light mb-0 md:mb-2 text-center lg:text-left">
                            Monitoramento <br /> de{" "}
                            <span className="bg-gradient-to-r from-[#FC0021] via-[#FC0021] to-[#5534D9] bg-clip-text text-transparent">
                                Segurança
                            </span>
                        </h2>
                    </div>
                    <div className="lg:w-2/3">
                        <p className="text-center lg:text-left text-[18px] md:text-2xl">
                            Identifique atividades suspeitas e vulnerabilidades
                            instantaneamente, garantindo a proteção dos dados e
                            das suas aplicações.
                        </p>
                    </div>
                </Container>
            </section>
            <section className="bg-[url(../assets/cover-proposito.png)] bg-no-repeat bg-cover">
                <article>
                <div className="w-full bg-[rgba(4,1,22,1)] pt-8 pb-14 lg:pt-16 lg:pb-40 relative overflow-hidden">
                        <Container className="relative z-10">
                            <>
                                <h3 className="font-inter-light text-2xl md:text-[40px] mb-7 md:mb-14 text-center text-white">
                                    Benefícios:
                                </h3>

                                {/* All 3 cards in one row */}
                                <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-6">
                                    {beneficios.map((card, index) => (
                                        <div key={index} className="relative">
                                            <div
                                                className="relative"
                                                onMouseEnter={() =>
                                                    setHoveredBeneficioIndex(
                                                        index
                                                    )
                                                }
                                                onMouseLeave={() =>
                                                    setHoveredBeneficioIndex(
                                                        null
                                                    )
                                                }
                                            >
                                                <CardServicos
                                                    icon={card.icon}
                                                    iconHover={
                                                        card.iconHover ||
                                                        card.icon
                                                    }
                                                    title={card.title}
                                                    text={card.text}
                                                    glowColor={
                                                        card.glowColor ||
                                                        "#A002CB"
                                                    }
                                                    url={card.url}
                                                    className="w-full"
                                                />

                                                {/* OtimizeSeuNegocio component that appears on hover */}
                                                <div
                                                    className={`absolute left-0 right-0 bottom-[-110px] transition-all duration-300 ${
                                                        hoveredBeneficioIndex ===
                                                        index
                                                            ? "opacity-100 visible"
                                                            : "opacity-0 invisible"
                                                    }`}
                                                >
                                                    <OtimizeSeuNegocio
                                                        text="Otimize seu negócio!"
                                                        buttonText="Contratar"
                                                        useFormularioRD={true}
                                                        type="solidOrange"
                                                        className="w-full"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="md:hidden space-y-3">
                                    {beneficios.map((card, index) => (
                                        <div key={index} className="relative">
                                            <AccordionServicos
                                                {...card}
                                                className="text-left"
                                                doesThereButton={false}
                                                onToggle={(isOpen) => handleAccordionToggle(`beneficio-${index}`, isOpen)}
                                                accordionIndex={`beneficio-${index}`}
                                                isOpen={expandedMobileIndex === `beneficio-${index}`}
                                            />
                                            
                                            {/* Otimize component that appears when accordion is expanded */}
                                            <div 
                                                className={`transition-all duration-300 ease-in-out transform w-full overflow-hidden
                                                    ${expandedMobileIndex === `beneficio-${index}` ? 'max-h-[100px] opacity-100 mt-3' : 'max-h-0 opacity-0'}`}
                                                style={{
                                                    transitionProperty: 'max-height, opacity, transform, margin',
                                                    transform: expandedMobileIndex === `beneficio-${index}` ? 'translateY(0)' : 'translateY(-10px)',
                                                    zIndex: 20,
                                                    position: 'relative'
                                                }}
                                            >
                                                <OtimizeSeuNegocio 
                                                    text="Otimize seu negócio!"
                                                    buttonText="Contratar"
                                                    useFormularioRD={true}
                                                    type="solidOrange"
                                                    className="w-full"
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        </Container>
                    </div>
                </article>
            </section>
            <BusinessOtimize
                title={
                    <>
                        <span className="font-inter-bold">
                            Segurança aprimorada e controle em tempo real
                        </span>
                        <br />
                        para antecipar problemas e resoluções ágeis com total
                        eficiência.
                    </>
                }
                buttonText="Otimize seu negócio!"
                buttonTextColor="from-[#FC0021] to-[#FC0021]"
                backgroundImage="../assets/cloud-red.png"
                bgMobile="../assets/cloud-red.png"
                buttonLink="/"
            />
            <Rodape />
        </>
    );
}
